import { createAction, props } from '@ngrx/store';
import { CreateCorrectiveActionRequest } from '../../models/requests/create-corrective-action-request';
import { UpdateCorrectiveActionRequest } from '../../models/requests/update-corrective-action-request';
import { CorrectiveAction } from '../../models/corrective-action.model';

// Load actions
export const loadCorrectiveAction = createAction(
  '[correctiveAction] Load Corrective Action',
  props<{ ruleUid: string | undefined }>()
);
export const loadCorrectiveActionSuccess = createAction(
  '[correctiveAction] Load Corrective Action Success',
  props<{ correctiveAction: CorrectiveAction[] }>()
);
export const loadCorrectiveActionFailure = createAction(
  '[correctiveAction] Load Corrective Action Failure',
  props<{ error: any }>()
);

// Delete actions
export const deleteMultipleCorrectiveActions = createAction(
  '[correctiveAction] Delete Multiple Corrective Actions',
  props<{ uids: string[] }>()
);
export const deleteMultipleCorrectiveActionsSuccess = createAction(
  '[correctiveAction] Delete Multiple Corrective Actions Success',
  props<{ uids: string[] }>()
);
export const deleteMultipleCorrectiveActionsFailure = createAction(
  '[correctiveAction] Delete Multiple Corrective Actions Failure',
  props<{ error: any }>()
);

// Create actions
export const createMultipleCorrectiveActions = createAction(
  '[correctiveAction] Create Multiple Corrective Actions',
  props<{ requests: CreateCorrectiveActionRequest[] }>()
);
export const createMultipleCorrectiveActionsSuccess = createAction(
  '[correctiveAction] Create Multiple Corrective Actions Success',
  props<{ correctiveActions: CorrectiveAction[] }>()
);
export const createMultipleCorrectiveActionsFailure = createAction(
  '[correctiveAction] Create Multiple Corrective Actions Failure',
  props<{ error: any }>()
);

// Update actions
export const updateMultipleCorrectiveActions = createAction(
  '[correctiveAction] Update Multiple Corrective Actions',
  props<{ requests: UpdateCorrectiveActionRequest[] }>()
);
export const updateMultipleCorrectiveActionsSuccess = createAction(
  '[correctiveAction] Update Multiple Corrective Actions Success',
  props<{ correctiveActions: CorrectiveAction[] }>()
);
export const updateMultipleCorrectiveActionsFailure = createAction(
  '[correctiveAction] Update Multiple Corrective Actions Failure',
  props<{ error: any }>()
);
